import type { ILoadingIndicator } from '../../types/loading_indicator';
import { AnimatedLoadingIndicator } from '@unified-checkout/design-system/icons/index';
import styles from './loading-indicator.module.scss';

export const LoadingIndicator = ({
  size = 'sm',
  text = 'Loading...'
}: ILoadingIndicator) => {
  return (
    <div
      className={styles['loading-indicator']}
      data-loading-indicator-size={size}
    >
      {AnimatedLoadingIndicator}
      {text}
    </div>
  )
};